// extracted by mini-css-extract-plugin
module.exports = {"header":"index_header_3uCLS","title":"index_title_1mQuq","body":"index_body_1wfNu"};